import { render, staticRenderFns } from "./presens-av-sein.vue?vue&type=template&id=04eb05d8&scoped=true"
import script from "./presens-av-sein.vue?vue&type=script&lang=js"
export * from "./presens-av-sein.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb05d8",
  null
  
)

export default component.exports